var map = {
	"./add-donation.svg": "fb2a",
	"./auctions.svg": "66e6",
	"./badge-add-donation.svg": "5693",
	"./donations.svg": "1545",
	"./logo.svg": "9b19",
	"./spending.svg": "54a7",
	"./ttu-coin-donation.svg": "d006",
	"./ttuToken.svg": "a50a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";